import { ROUTE_PATH, TEMPLATE_OPTIONS, ASSIGNMENT_STATUS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaInputModel } from "common/models/utility-models/meta-model";

export class AssignmentFilterMetaModel extends FormMetaModel {
    constructor() {
      super('', ROUTE_PATH.assignmentGrid, ROUTE_PATH.assignmentForm, 3);
    }
  
    override initProperties(): any {
      const formInfo = super.initProperties();
      const selectedBatch = new SmMetaSelectModel(
        'selectedBatch',
        'selectedBatch',
        'select',
        false,
        'col-sm-6 col-xs-12 col-md-4 col-lg-2',
        1,
        3,
        '',
        'select',
        'Batch',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        TEMPLATE_OPTIONS,
        'batch_number',
        'batch_number'
      );
      const selectedRegion = new SmMetaSelectModel(
        'selectedRegion',
        'selectedRegion',
        'select',
        false,
        'col-sm-6 col-xs-12 col-md-4 col-lg-2',
        1,
        3,
        '',
        'select',
        'Region',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        TEMPLATE_OPTIONS,
        'zone_name',
        'zone_name'
      );
      const selectedLocation = new SmMetaSelectModel(
        'selectedLocation',
        'selectedLocation',
        'select',
        false,
        'col-sm-6 col-xs-12 col-md-4 col-lg-2',
        1,
        3,
        '',
        'select',
        'Location',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        TEMPLATE_OPTIONS,
        'city_name',
        'city_name'
      );
      const selectedType = new SmMetaSelectModel(
        'selectedType',
        'selectedType',
        'select',
        false,
        'col-sm-6 col-xs-12 col-md-4 col-lg-2',
        1,
        3,
        '',
        'select',
        'Type',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        TEMPLATE_OPTIONS,
        'type_name',
        'type_name'
      );
      const selectedStatus = new SmMetaSelectModel(
        'selectedStatus',
        'selectedStatus',
        'select',
        false,
        'col-sm-6 col-xs-12 col-md-4 col-lg-2',
        1,
        3,
        '',
        'select',
        'Status',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        ASSIGNMENT_STATUS,
        'name',
        'id'
      );
      const search = new SmMetaInputModel(
        'search',
        'search',
        'input',
        false,
        'col-3',
        1,
        3,
        '',
        'text',
        '',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      return {
        formInfo,
        selectedBatch,
        selectedRegion,
        selectedLocation,
        selectedStatus,
        selectedType,
        search,
      };
    }
  }